
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"disableAutoPopup":"Do not display this message again."},"de":{"disableAutoPopup":"Diesen Hinweis zukünftig nicht mehr automatisch anzeigen."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();